import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Reservation } from './reservation.model';
import { ReservationSummaryApiService } from './reservation-summary/services/reservation-summary-api.service';
import { inject } from '@angular/core';

export const reservationResolver: ResolveFn<Reservation> = async (route: ActivatedRouteSnapshot) => {
	const reservationSummaryApiService = inject(ReservationSummaryApiService);
	const { getReservation } = reservationSummaryApiService.actions();
	const reservationId = route.params.id;

	if (!reservationId) {
		throw new Error('reservationId is falsy value!');
	}

	const reservation = await getReservation(reservationId);

	return reservation;
};
